<template>
  <div class="sessions fullWidth fCol jCenter aCenter">
    <div class="closer" @click="closeKPI"></div>
    <div class="box fCol jStart aStart" v-if="loaded">
      <div class="fullWidth fRow jStart aCenter header">
        <i class="material-icons-round">flag</i>
        <span>ثبت و مشاهده‌ی تارگت‌های {{data.fullName}}</span>
      </div>
      <div class="fullWidth fCol jStart aStart inputHolder">
        <span class="fRow jStart aCenter">
          <i class="material-icons-round"
            v-bind:class="{inpErr: kpiDateErr}">date_range</i>
          انتخاب سال</span>
        <div class="years fullWidth fRow jCenter aCenter">
          <div class="fRow jBetween aCenter fullWidth inputWraper wrap years">
            <div class="w33 jCenter aCenter month"
              @click="selectYear(item)"
              v-bind:class="{
                selected: KPIdate.year === item,
              }"
              v-for="(item, index) in years" v-bind:key="index">
              {{item}}
            </div>
          </div>
        </div>
      </div>
      <div class="fullWidth fCol jStart aStart inputHolder">
        <span class="fRow jStart aCenter">
          <i class="material-icons-round"
            v-bind:class="{inpErr: kpiDateErr}">date_range</i>
          انتخاب ماه</span>
        <div class="fCol jBetween aCenter fullWidth inputWraper wrap months">
          <div class="w25 jCenter aCenter month"
            @click="selectMonth(item.month)"
            v-bind:class="{
              selected: item.month === KPIdate.month,
              disable: inputDisabled,
            }"
            v-for="(item, index) in months" v-bind:key="index">
            {{item.label}}
          </div>
        </div>
      </div>
      <div class="fullWidth fCol jStart aStart inputHolder">
        <span class="fRow jStart aCenter">
          <i class="material-icons-round"
            v-bind:class="{inpErr: amountErr}">flag</i>
          مبلغ تارگت به تومان</span>
        <div class="fRow jStart aCenter fullWidth inputWraper">
          <input class="transition-fast" placeholder="مبلغ تارگت (تومان)"
            :disabled="inputDisabled"
            type="text" v-model="amount">
        </div>
      </div>
      <!-- <div class="kpiDateShow">{{KPIdateShow}}</div> -->
      <div class="b fRow jCenter aCenter fullWidth big"
        @click="putKpi"
        v-bind:class="{
          active: targetReady,
        }"
        style="margin-top: 8px">
        <i class="material-icons-round">flag</i>
        <label>ثبت تارگت</label>
      </div>
    </div>
    <div class="box fCol jCenter aCenter" v-if="loading || noContent">
      <p-bar
        :loading="loading"
        :notYet="notYet"
        :noContent="noContent"
        :notFound="notFound"
        :error="error" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment-jalaali';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';
import pBar from '@/components/pBar.vue';

export default {
  mixins: [errorHandler, makeToast],
  props: ['data'],
  data() {
    return {
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      // modes ↓
      loading: false,
      noContent: false,
      notFound: false,
      error: false,
      notYet: false,
      loaded: true,
      modeMsg: '',
      // modes ↑
      name: 'mehdi',
      kpiDateErr: true,
      KPIdate: {},
      KPIdateShow: '',
      kpiArray: [],
      years: [1399, 1400, 1401],
      selectedYear: '',
      currentYear: 0,
      prevYear: 0,
      nextYear: 0,
      currentMonth: 0,
      months: [
        {
          month: 1,
          label: 'فروردین',
        },
        {
          month: 2,
          label: 'اردیبهشت',
        },
        {
          month: 3,
          label: 'خرداد',
        },
        {
          month: 4,
          label: 'تیــر',
        },
        {
          month: 5,
          label: 'مرداد',
        },
        {
          month: 6,
          label: 'شهریور',
        },
        {
          month: 7,
          label: 'مهــر',
        },
        {
          month: 8,
          label: 'آبان',
        },
        {
          month: 9,
          label: 'آذر',
        },
        {
          month: 10,
          label: 'دی',
        },
        {
          month: 11,
          label: 'بهمن',
        },
        {
          month: 12,
          label: 'اسفند',
        },
      ],
      groupedByYear: [],
      amount: '',
      amountErr: true,
      inputDisabled: false,
    };
  },
  components: {
    pBar,
  },
  methods: {
    closeKPI() {
      this.$emit('close');
    },
    commaSep(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    setMode(m, msg) {
      this.noContent = false;
      this.loading = false;
      this.notYet = false;
      this.error = false;
      this.loaded = false;
      this.modeMsg = '';
      switch (m) {
        case 'loading': {
          this.loading = true;
          break;
        }
        case 'loaded': {
          this.loaded = true;
          break;
        }
        case 'error': {
          this.modeMsg = msg;
          this.error = true;
          break;
        }
        case 'notYet': {
          this.notYet = true;
          break;
        }
        case 'noContent': {
          this.noContent = true;
          break;
        }
        default:
          break;
      }
    },
    selectYear(y) {
      this.KPIdate.year = y;
      // eslint-disable-next-line
      if (y === this.prevYear || (y === this.currentYear && this.KPIdate.month < this.currentMonth)) {
        this.inputDisabled = true;
      } else {
        this.inputDisabled = false;
      }
      this.selectMonth(1);
    },
    selectMonth(m) {
      this.KPIdate.month = m;
      // eslint-disable-next-line
      if (this.KPIdate.year === this.prevYear || (this.KPIdate.year === this.currentYear && m < this.currentMonth)) {
        this.inputDisabled = true;
      } else {
        this.inputDisabled = false;
      }
      this.getSelectedMonthValue();
    },
    isThisYearInHistory(y) {
      const c = this.kpiArray;
      // console.warn(c[0], y);
      let ind = -1;
      for (let i = 0; i < c.length; i += 1) {
        if (c[i].year === y) {
          ind = i;
        }
      }
      return ind;
    },
    getKpi() {
      // console.log('get kpi for ', this.data.id);
      this.setMode('loading');
      // eslint-disable-next-line
      let reqUrl = `${this.baseURL}/api/v${this.V}/Consultants/kpi/${this.data.id}`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          const a = response.data.data;
          this.kpiArray = a;
          // console.log(this.kpiArray);
          this.setMode('loaded');
          this.initForm();
        } else {
          this.makeToast('error', 'خطا در بارگذاری', 3000);
          this.setMode('error', 'خطا در بارگذاری');
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    putKpi() {
      if (this.targetReady) {
        // console.log('put kpi for ', this.data.id);
        this.setMode('loading');
        // eslint-disable-next-line
        let reqUrl = `${this.baseURL}/api/v${this.V}/Consultants/kpi/${this.data.id}`;
        axios({
          method: 'put',
          url: reqUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            year: this.KPIdate.year,
            month: this.KPIdate.month,
            price: parseInt(this.amount.replace(/,/g, ''), 10),
          },
        }).then((response) => {
          if (response.data.isSuccess) {
            this.makeToast('success', 'تارگت مورد نظر ثبت شد', 3000);
            this.closeKPI();
          } else {
            this.makeToast('error', response.data.message, 3000);
            this.setMode('error', response.data.message);
          }
        }, (error) => {
          this.makeToast('error', this.errorHandler(error), 3000);
          // console.log(error);
        });
      } else {
        this.makeToast('error', 'امکان ثبت تارگت برای این تاریخ وجود ندارد', 3000);
      }
    },
    initForm() {
      const d = new Date();
      this.currentYear = parseInt(moment(d).locale('fa').format('jYYYY'), 10);
      this.currentMonth = parseInt(moment(d).locale('fa').format('jMM'), 10);
      this.KPIdate = {
        year: this.currentYear,
        month: this.currentMonth,
      };
      // check kpi array
      this.prevYear = this.currentYear - 1;
      this.nextYear = this.currentYear + 1;
      this.groupedByYear = [
        {
          year: this.prevYear,
          items: [],
        },
        {
          year: this.currentYear,
          items: [],
        },
        {
          year: this.nextYear,
          items: [],
        },
      ];
      if (this.kpiArray !== null) {
        for (let i = 0; i < this.kpiArray.length; i += 1) {
          if (this.kpiArray[i].year === this.prevYear) {
            this.groupedByYear[0].items = this.kpiArray[i].items;
          }
          if (this.kpiArray[i].year === this.currentYear) {
            this.groupedByYear[1].items = this.kpiArray[i].items;
          }
          if (this.kpiArray[i].year === this.nextYear) {
            this.groupedByYear[2].items = this.kpiArray[i].items;
          }
        }
      }
      this.selectYear(this.currentYear);
      this.selectMonth(this.currentMonth);
    },
    getSelectedMonthValue() {
      let tempMonthArray = [];
      switch (this.KPIdate.year) {
        case (this.currentYear - 1): {
          // console.log('its prev year');
          tempMonthArray = this.groupedByYear[0].items;
          break;
        }
        case (this.currentYear): {
          // console.log('its current year');
          tempMonthArray = this.groupedByYear[1].items;
          break;
        }
        case (this.currentYear + 1): {
          // console.log('its next year');
          tempMonthArray = this.groupedByYear[2].items;
          break;
        }
        default:
          break;
      }
      const d = this.haveData(tempMonthArray, this.KPIdate.month);
      if (d !== false) {
        this.amount = `${d}`;
      } else {
        this.amount = 'دیتا ثبت نشده';
      }
    },
    haveData(arr, month) {
      const a = arr;
      let value = false;
      for (let i = 0; i < a.length; i += 1) {
        if (a[i].month === month) {
          value = a[i].price;
        }
      }
      return value;
    },
  },
  computed: {
    targetReady() {
      return !this.amountErr
        && !this.inputDisabled;
    },
  },
  watch: {
    KPIdate() {
      // if (this.KPIdate !== {}) {
      // console.log('date', this.KPIdate);
      //   const y = this.KPIdate.year;
      //   const m = this.months[this.KPIdate.month - 1];
      //   // this.KPIdateShow = moment(this.KPIdate, 'YYYY-MM')
      //   //   .locale('FA')
      //   //   .format('jMMMM ');
      //   this.KPIdateShow = `${m} ${y}`;
      //   this.kpiDateErr = false;
      // } else {
      //   this.KPIdateShow = '';
      //   this.kpiDateErr = true;
      // }
    },
    amount() {
      let p = this.amount;
      p = p.replace(/,/g, '');
      if (!/^\d+$/.test(p) || (p.charAt(0) === '0' || p.charAt(0) === 0)) {
        p = p.substr(0, p.length - 1);
      }
      if (p.length > 12) {
        this.amount = this.amount.substr(0, 12);
      }
      p = this.commaSep(p);
      this.amount = p;
      if (this.amount.length > 3) {
        this.amountErr = false;
      } else {
        this.amountErr = true;
      }
    },
  },
  mounted() {
    this.getKpi();
  },
};
</script>

<style lang="scss" scoped>
.sessions {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba($color: #000000, $alpha: 0.25);
  z-index: 9999999999999 !important;
  .closer {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 100;
  }
  .box {
    padding: 16px 32px;
    z-index: 2000;
    width: 80%;
    max-width: 400px;
    max-height: 75vh;
    overflow: hidden auto;
    border-radius: 16px;
    box-shadow: 0 16px 24px -12px rgba($color: #000000, $alpha: 1.0);
    background-color: white;
    .header {
      padding: 8px 0;
      margin-bottom: 16px;
      i {
        color: rgba($color: #000000, $alpha: 0.75);
        margin-left: 8px;
      }
      span {
        font-size: 14px;
        font-weight: bold;
      }
    }
    .months, .years {
      margin: 16px 0;
      height: 100px;
      .month {
        border-radius: 16px;
        background-color: rgba($color: #000000, $alpha: 0.1);
        text-align: center !important;
        padding: 4px 8px;
        font-size: 12px;
        margin-bottom: 4px;
        opacity: 0.7;
        cursor: pointer;
        transition: all ease-in-out 0.3s;
      }
      .month.disable {
        opacity: 0.5;
        pointer-events: unset !important;
      }
      .month.disable.selected {
        opacity: 1 !important;
        background-color: rgba($color: #000000, $alpha: 0.35) !important;
        color: black;
      }
      .month:hover {
        opacity: 1;
      }
      .month.selected {
        background-color: rgb(55, 145, 55) !important;
        opacity: 1 !important;
        color: white !important;
      }
    }
    .years {
      height: unset !important;
      margin: 8px 0;
    }
  }
}
</style>
